module.exports = __webpack_public_path__ + "img/icon_map_188_off_001.6d84b092.png";